/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'macbookpro_dark_large': {
    width: 58,
    height: 54,
    viewBox: '0 0 58 54',
    data: '<path pid="0" _fill="#C4FFF9" d="M52.987 48V20.503a1.47 1.47 0 0 0-1.491-1.49H6.503c-.848 0-1.49.658-1.49 1.49V48H0v1.428C.639 50.463 4.094 51 5.465 51h46.696c1.372 0 5.2-.537 5.839-1.572V48h-5.013zM7 21h44v27H7V21z"/>'
  }
})
